import * as React from 'react'

import { Template } from './Template'
import { useViewModel } from './useViewModel'

import type { Props } from './types'

export const SearchPageView: React.FC<Props> = props => {
  return <Template {...useViewModel(props)} />
}
